const ProcurementProjectType = {
  GET_PROCUREMENT_PROJECT_LIST: 'GET_PROCUREMENT_PROJECT_LIST',
  GET_PROCUREMENT_PROJECT_LIST_SUCCESS: 'GET_PROCUREMENT_PROJECT_LIST_SUCCESS',
  GET_PROCUREMENT_PROJECT_LIST_FAIL: 'GET_PROCUREMENT_PROJECT_LIST_FAIL',
  GET_PROCUREMENT_PROJECT_LIST_REQUEST_RESET: 'GET_PROCUREMENT_PROJECT_LIST_REQUEST_RESET',
  UPDATE_PROCUREMENT_PROJECT_INFO_REQUEST: 'UPDATE_PROCUREMENT_PROJECT_INFO_REQUEST',
  PROCUREMENT_PROJECT_LIST_UPDATE: 'PROCUREMENT_PROJECT_LIST_UPDATE',

  CHECK_PROJECT_NAME_IS_EXISTS: 'CHECK_PROJECT_NAME_IS_EXISTS',
  CHECK_PROJECT_NAME_IS_EXISTS_SUCCESS: 'CHECK_PROJECT_NAME_IS_EXISTS_SUCCESS',
  CHECK_PROJECT_NAME_IS_EXISTS_FAIL: 'CHECK_PROJECT_NAME_IS_EXISTS_FAIL',

  GET_USER_PROCUREMENT: 'GET_USER_PROCUREMENT',
  GET_USER_PROCUREMENT_SUCCESS: 'GET_USER_PROCUREMENT_SUCCESS',
  GET_USER_PROCUREMENT_FAIL: 'GET_USER_PROCUREMENT_FAIL',
  GET_USER_PROCUREMENT_REQUEST_RESET: 'GET_USER_PROCUREMENT_REQUEST_RESET',

  GET_TENDER_BY_PROJECT_LIST: 'GET_TENDER_BY_PROJECT_LIST',
  GET_TENDER_BY_PROJECT_LIST_SUCCESS: 'GET_TENDER_BY_PROJECT_LIST_SUCCESS',
  GET_TENDER_BY_PROJECT_LIST_FAIL: 'GET_TENDER_BY_PROJECT_LIST_FAIL',
  GET_TENDER_BY_PROJECT_LIST_REQUEST_RESET: 'GET_TENDER_BY_PROJECT_LIST_REQUEST_RESET',

  CREATE_UPDATE_PROJECT: 'CREATE_UPDATE_PROJECT',
  CREATE_UPDATE_PROJECT_SUCCESS: 'CREATE_UPDATE_PROJECT_SUCCESS',
  CREATE_UPDATE_PROJECT_FAIL: 'CREATE_UPDATE_PROJECT_FAIL',
  CREATE_UPDATE_PROJECT_REQUEST_RESET: 'CREATE_UPDATE_PROJECT_REQUEST_RESET',

  CREATE_PROJECT_COPY: 'CREATE_PROJECT_COPY',
  CREATE_PROJECT_COPY_SUCCESS: 'CREATE_PROJECT_COPY_SUCCESS',
  CREATE_PROJECT_COPY_FAIL: 'CREATE_PROJECT_COPY_FAIL',
  CREATE_PROJECT_COPY_RESET: 'CREATE_PROJECT_COPY_RESET',

  SET_ACTIVE_PROJECT_ITEM: 'SET_ACTIVE_PROJECT_ITEM',
  RESET_ACTIVE_PROJECT_ITEM: 'RESET_ACTIVE_PROJECT_ITEM',
  SET_SELECTED_PROJECT_ACTION: 'SET_SELECTED_PROJECT_ACTION',
};

export default ProcurementProjectType;
